export enum CountryCode {
    unitedStates = 'US',
    australia = 'AU',
    newZealand = 'NZ',
    netherlands = 'NL',
}
